import type { PublicArticle } from '../core/models/public-article';

/**
 * This article's URL per language — its own, plus each alternate the server declared.
 *
 * **An alternate arrives only where the counterpart is actually published**, so a language missing
 * from here has no page rather than an empty one. That is what keeps the header's language switch
 * off a 404 on the one page type whose path is not the same in both languages: an article's slug is
 * per language by construction, so rewriting the `/kk` prefix produces a Russian URL carrying a
 * Kazakh slug.
 *
 * The same map is what `usePageMetadata` emits as `hreflang`, which is why it is one function and
 * not two: a switcher offering a language the metadata does not declare, or the reverse, is a
 * disagreement a crawler notices before anybody here does.
 */
export function buildAlternatePaths(article: PublicArticle, language: string): Record<string, string> {
    const paths: Record<string, string> = { [language]: `/${language}/blog/${article.slug}` };

    for (const alternate of article.alternates) {
        paths[alternate.language] = `/${alternate.language}/blog/${alternate.slug}`;
    }

    return paths;
}
